/**
 * PromoCard — used in hero carousel + promotions section.
 */
export default function PromoCard({ image, title, subtitle, cta, onCta, variant = "hero", className = "", testid }) {
  if (variant === "tile") {
    return (
      <div className={`relative overflow-hidden rounded-xl border border-line group cursor-pointer bg-elevated ${className}`} onClick={onCta} data-testid={testid}>
        <div className="aspect-[21/9] w-full">
          <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-base/95 via-base/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="font-display italic text-xl text-ink mb-1">{title}</div>
          {subtitle && <div className="text-xs text-ink-2 mb-3">{subtitle}</div>}
          {cta && <div className="inline-flex items-center gap-1 text-xs tracking-[0.2em] uppercase text-pink">{cta} →</div>}
        </div>
      </div>
    );
  }
  return (
    <div className={`relative overflow-hidden rounded-2xl border border-line ${className}`} data-testid={testid}>
      <div className="aspect-[21/9] w-full">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-base via-base/85 to-base/20" />
      <div className="absolute inset-0 flex items-center px-6 sm:px-12 lg:px-16">
        <div className="max-w-lg">
          <div className="text-[10px] tracking-[0.4em] uppercase text-pink mb-3">Bra Game</div>
          <h2 className="font-display italic text-3xl sm:text-4xl lg:text-5xl text-ink leading-tight mb-3 drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)]">{title}</h2>
          {subtitle && <p className="text-sm sm:text-base text-ink mb-6 max-w-md drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">{subtitle}</p>}
          {cta && (
            <button onClick={onCta} className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-brand-gradient text-white text-sm font-medium shadow-glow-pink hover:brightness-110 hover:scale-[1.02] transition" data-testid={`${testid}-cta`}>
              {cta}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
